<template>
  <div>
    
    <!-- Navbar -->
    <nav id="navigationBar">
      <div class="container-fluid">
        <div class="navbar">
          <div class="nav-logo">
            <router-link :to="{ name: 'home' }">
              <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')" class="img-fluid" alt="Logo" /> 
              <div class="logo-title main-color"  v-html="logo.title ? logo.title : 'AISN'"></div>
            </router-link>
          </div>

          <div class="nav-links">
            <router-link v-if="(header[0]) ? header[0].status : false" 
                        to="/accreditations" class="nav-link">Accreditation</router-link>
            <router-link v-if="(header[8]) ? header[8].status : false"
                        to="/our-certificates" class="nav-link">Certification</router-link>
            <router-link v-if="(header[1]) ? header[1].status : false" 
                        to="/programs" class="nav-link">Programs</router-link>
            <router-link v-if="(header[2]) ? header[2].status : false" 
                        to="/memberships" class="nav-link">Membership</router-link>
            <router-link v-if="(header[3]) ? header[3].status : false" 
                        to="/about" class="nav-link">About</router-link>
            <router-link v-if="(header[4]) ? header[4].status : false" 
                        to="/contact" class="nav-link">Contact Us</router-link>
            <a @click="opnPopular(pop.slug)"  class="nav-link hidden-sm"
                v-for="(pop, idx) in popularSearch" :key="'s'+idx">
              {{ pop.title }}
            </a>

              <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                  :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                  class="nav-link"
                  :class="(pg.has_header) ? '' : 'hidden' ">
                  {{ pg.title }}
              </router-link>
          </div>

          <div class="nav-btns d-flex align-items-center">
            <div class="us d-flex align-items-center dropdown">

              <button v-if="authenticated"
                  type="button"
                  name="button"
                  class="navbar-action hidden-sm"
                  data-toggle="dropdown">
                <div class="showDropdown">
                    <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                        alt="" 
                        class="img-fluid" 
                        style="width:30px;height:30px;border-radius: 50%;">
                    <div class="dropdown-menu">
                      <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                      <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                    </div>
                </div>
              </button>

              <router-link v-if="!authenticated" to="/login">
                <button type="button" class="d-flex align-items-center">
                  <span class="icon-user"></span>
                </button>
              </router-link>

              <span class="ml-3 mr-3 vertical-line">|</span>

              <button @click="toggleSearch = !toggleSearch" class="d-flex align-items-center">
                    <span v-if="!toggleSearch" class="icon-search"></span>
                    <span v-else class="icon-cancel"></span>
              </button>

            </div>
            <div id="menuBtn" class="menu-btn">
              <span class="top-bar"></span>
              <span class="middle-bar"></span>
              <span class="bottom-bar"></span>
              <div class="menu-text">Menu</div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- Navbar -->
    <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped="">
.hidden { display: none !important }
.dropdown-menu {
  left: auto;
  right: 0;
}
.logo-title {
  margin-left: 10px;
}
</style>

<script>
import axios from "axios";
import SearchPopup from './SearchPopup';
export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: '',
      authenticated: false,
      toggleSearch: false,
      popularSearch: []
    };
  },
  created() {
    // Get Navbar Links
    axios
      .get(window.baseURL + "/popularSearch")
      .then((res) => {
        var data = res.data.rows;
        this.popularSearch = res.data.rows;
      })
      .catch(() => {});

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  mounted() {
    $(document).ready(function () {
        $("#menuBtn").on('click', function () {
            $('.nav-links').toggleClass('active');
            $(this).toggleClass('active');
        });

        if ($(window).scrollTop() > 0) {
            $('#navigationBar').addClass('active');
        } 
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('#navigationBar').addClass('active');
        } else {
            $('#navigationBar').removeClass('active');
        }
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },
    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = 
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
        })
        .catch(() => {});
    },


    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

    openMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.add('active');
        el2.classList.add('active');
    },

    closeMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.remove('active');
        el2.classList.remove('active');
    }

  }
};
</script>
